export const getLetters = [
    'q',
    'w',
    'e',
    'r',
    't',
    'y',
    'u',
    'i',
    'o',
    'p',
    'a',
    's',
    'd',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    'enter',
    'z',
    'x',
    'c',
    'v',
    'b',
    'n',
    'm',
    'delete',
];
